import React from 'react'

import assets from 'xui/assets'

import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'
import XSellyLogo from './XSellyLogo'

interface ICrmLogoProps extends ICommonLogoOptionalProps {
  crmSystemId: number
}

const CrmLogo = (props: ICrmLogoProps) => {
  switch (props.crmSystemId) {
    case 1:
      return <CommonLogo source={assets.images.crm.deepblok} width={22} height={22} borderRadius='full' {...props} />
    default:
      return <XSellyLogo {...props} />
  }
}

export default CrmLogo
